import type { SVGProps } from 'react'

const UserFriendlyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <rect
      x="12.9065"
      y="18.9065"
      width="14.6133"
      height="8.40121"
      rx="0.906479"
      fill="white"
      stroke="#2563EB"
      strokeWidth="1.81296"
    />
    <rect
      x="12.9065"
      y="32.1389"
      width="14.6132"
      height="8.40121"
      rx="0.906479"
      fill="white"
      stroke="#2563EB"
      strokeWidth="1.81296"
    />
    <rect
      x="32.1614"
      y="18.9065"
      width="14.6133"
      height="21.6348"
      rx="0.906479"
      fill="white"
      stroke="#2563EB"
      strokeWidth="1.81296"
    />
  </svg>
)

export default UserFriendlyIcon
